import { DispatchLoading, DispatchType, ResponseValid } from "domain/utils/ReactUtils";
import { AppThunk } from "base/src/utils/reducerUtil";
import { ExtratoRequest } from "domain/types/_carteira/extrato/extratoRequest";
import { ExtratoService } from "carteira/src/services/extrato/extratoService";
import { EXTRATO_RANGE } from 'domain/types/_carteira/extrato/extrato';
import { StateType } from "domain/types/base/base";

const _ExtratoService = new ExtratoService();
export function GetExtrato(request: ExtratoRequest, carteiraId: number, callback: () => void): AppThunk {
  return async (dispatch) => {
    dispatch(DispatchLoading(EXTRATO_RANGE, DispatchType.LOADING, 'Carregando', StateType.Master));

    const asyncResponse = await _ExtratoService.GetExtrato(request, carteiraId);

    if (ResponseValid(asyncResponse, false, dispatch)) {
      dispatch({
        payload: asyncResponse,
        type: EXTRATO_RANGE
      });

      callback();

      dispatch(DispatchLoading(EXTRATO_RANGE, DispatchType.SUCCESS));
    }
  };
}
